import * as caseErrorMapper from 'modules/cm/api/cases/caseError/mapper';
import { ValidationError as ApiValidationError } from 'modules/cm/api/pepper/errors/ValidationError';
import { CaseError } from 'modules/cm/domain/Case/Error';

export interface ValidationError extends CaseError {}

class PepperValidationError extends Error {
  private errors: ValidationError;

  constructor(data: ApiValidationError) {
    super('Pepper Validation Error');

    this.errors = Object.freeze(caseErrorMapper.apiToDomain(data));

    Object.setPrototypeOf(this, PepperValidationError.prototype);
  }

  getErrors() {
    return this.errors;
  }
}

export default PepperValidationError;
